import { match } from 'ts-pattern';
import { GenderType } from '@shared/types/gender.type';
export const mapDefaultProfileImageByGender = (gender: GenderType): string => {
  return match(gender).with(GenderType.Female, () => '/images/default/profile-female.png').with(GenderType.Male, () => '/images/default/profile-male.png').with(GenderType.NotSpecified, () => '/images/default/profile-other.png').otherwise(() => '/icons/user-profile.svg');
};